<template>
  <footer class="footer bg-light">
    <div class="container">
      <div class="row">
        <div class="col-12 h-100 text-center my-auto mx-auto">
          <ul class="list-inline mb-2">
            <li class="list-inline-item">
              <router-link to="/">Introduction</router-link>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <router-link to="/privacy">Privacy</router-link>
            </li>
            <li class="list-inline-item">&sdot;</li>
            <li class="list-inline-item">
              <router-link to="/app">Application</router-link>
            </li>
          </ul>
          <p class="text-muted small mb-4 mb-lg-0">&copy; Rhythm Reader 2025. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'bottom'
}
</script>

<style scoped>
.bottom{
  max-width: 600px;
}
footer.footer .container .row{
  text-align: center!important;
}

footer.footer {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
</style>
